import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import CloseIcon from "@mui/icons-material/Close";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import RadioButton from "../../../../../Components/Common/RadioButton/RadioButton";
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const HealthPopup: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [gender, setGender] = React.useState("");
  const [age, setAge] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const gender_data = [
    { Key: "Yes", value: "Yes" },
    { Key: "No", value: "No" },
  ];
  const age_data = [
    { label: "18 Years", value: "18 Years" },
    { label: "19 Years", value: "19 Years" },
    { label: "20 Years", value: "20 Years" },
    { label: "21 Years", value: "21 Years" },
  ];

  const adults = ["1 Adult", "2 Adults"];
  const child = ["0", "1", "2", "3","4"];

  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        // backdropClicked={() => value_update(attrName, false)}
      >
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid xs={10} className="headingTitle">
              <h3>
                <span>Add Your Details</span>
              </h3>
              <p>Kindly provide essential details about your Travel.</p>
            </Grid>
            <Grid xs={2} textAlign="right">
              <Link
                className="closeIcon"
                onClick={() => {
                  value_update(attrName, false);
                }}
              >
                <CloseIcon />
              </Link>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <Box className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={6}>
                <RadioButton options={adults} defaultSelected="1 Adult" />
              </Grid>
              <Grid xs={6}>
                <RadioButton options={child} defaultSelected="0" />
              </Grid>

              <Grid xs={6}>
                <SearchDropdown
                  class_name="inputField"
                  title="Age"
                  value={age}
                  attrName={setAge}
                  value_update={updateMasterState}
                  data={age_data}
                  warn_status={false}
                  error_message={"please select age"}
                />
              </Grid>
              <Grid xs={6}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={gender}
                  attrName={setGender}
                  value_update={updateMasterState}
                  dropdown_data={gender_data}
                  warn_status={false}
                />
              </Grid>

              <Grid xs={6}>
                <RKTextField
                  class_name="inputField"
                  title="Pin Code"
                  value={pincode}
                  attrName={setPincode}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>

              <Grid xs={6}>
                <RKTextField
                  class_name="inputField"
                  title="Mobile"
                  value={mobile}
                  attrName={setMobile}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField"
                  title="Email"
                  value={email}
                  attrName={setEmail}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </>
      </SlidingPanel>
    </>
  );
};

export default HealthPopup;
